import script from "./GlobalSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSearch.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalSearch.vue?vue&type=style&index=0&id=244c38a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-244c38a4"]])

export default __exports__